var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"editor",attrs:{"value":_vm.internalHtml,"options":_vm.options,"disabled":_vm.disabled},on:{"input":_vm.handleInput,"change":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'change' ].concat( args ));
},"ready":_vm.handleReady,"blur":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'blur' ].concat( args ));
},"focus":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'focus' ].concat( args ));
}}})}
var staticRenderFns = []

export { render, staticRenderFns }